import { useNavigate } from 'react-router-dom';
import { Link } from '@mui/material';
import logo from '../assets/branding/logos/logo-totvs-azul-escuro.svg';


export default function Logo() {
  const navigate = useNavigate();

  return (
    <Link
      onClick={() => navigate("/")}
      sx={{cursor: "pointer"}}
    >
      <img src={logo} alt="TOTVS Catálogo" style={{height: 60}} />
    </Link>
  );
}